import { logos } from '@headbox-ui/themes'
const { HeadBox } = logos

type LogoProps = {
    fill?: string
}

export const Logo = ({ fill }: LogoProps) => <HeadBox width={200} fill={fill} />
